import SecondFold from '@components/referral-page/second-fold'
import BrandLogo from '@components/common/brand-logo'
import FirstFold from '@components/referral-page/first-fold'
import { currentYear } from '@lib/utils/date.utils'
import { NextPage } from 'next'
import { Heart } from 'react-feather'
import Institutions from '@components/common/institutions'
import useIsIndia from '@hooks/useIsIndia'

const ReferralPage: NextPage = () => {
  const { isIndia } = useIsIndia()
  return (
    <div className="bg-white">
      <div className="container mx-auto">
        <header className="py-8 flex justify-center items-center">
          <BrandLogo height={50.22} width={192} type="main-with-text" />
        </header>
        <FirstFold />
        <SecondFold />
        {isIndia && (
          <div className="py-8">
            <p className="text-center font-500 mb-2">Supported By</p>
            <Institutions />
          </div>
        )}
        <footer className="py-4 flex justify-center items-center text-xs lg:text-base">
          ©️ {currentYear} Codingal. Built with{' '}
          <Heart fill="red" stroke="red" size={15} className="inline mx-1" /> in
          India
        </footer>
      </div>
    </div>
  )
}

export default ReferralPage
